"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _stripCacheKeysFromData = _interopRequireDefault(require("@devsta/strip-cache-keys-from-data"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.uniq"));

var _lodash4 = _interopRequireDefault(require("lodash.sortby"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _AssetDrawer = _interopRequireDefault(require("./AssetDrawer"));

var _ReturnFeedbackModal = _interopRequireDefault(require("./ReturnFeedbackModal"));

var _Header = _interopRequireDefault(require("./Header"));

var _VideoContext = _interopRequireDefault(require("../contexts/VideoContext"));

var _defaultLabels = _interopRequireDefault(require("../constants/defaultLabels"));

var _videoToolContext = _interopRequireDefault(require("../selectors/videoToolContext"));

var _utils = require("../utils");

var _Stage = _interopRequireDefault(require("./Stage"));

var _SubmitForReviewApprovalModal = _interopRequireDefault(require("../pages/Summary/components/SubmitForReviewApprovalModal"));

var _pages = require("../pages");

require("../styles/_video-tool-root.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NEW_PROJECT = {
  assignedLabels: {},
  labels: _defaultLabels.default,
  assetIds: []
};

function sortClips(video) {
  return _objectSpread({}, video, {
    clips: (0, _lodash4.default)(video.clips, 'startTime')
  });
}

var VideoTool = /*#__PURE__*/function (_Component) {
  _inherits(VideoTool, _Component);

  var _super = _createSuper(VideoTool);

  function VideoTool(props) {
    var _this;

    _classCallCheck(this, VideoTool);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "getStageFromLocation", (0, _memoizeOne.default)(function (_ref) {
      var hash = _ref.hash;
      return hash ? parseInt(hash.substr(1), 10) : 1;
    }));

    _defineProperty(_assertThisInitialized(_this), "closePaymentsInvoiceModal", function () {
      _this.setState({
        showPaymentsInvoiceModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openPaymentsInvoiceModal", function () {
      _this.setState({
        showPaymentsInvoiceModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setCostReviewStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getOutputStatuses, _yield$getOutputStatu, error, data, hasCostReviewStatus;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getOutputStatuses = _this.props.getOutputStatuses;
              _context.next = 3;
              return getOutputStatuses();

            case 3:
              _yield$getOutputStatu = _context.sent;
              error = _yield$getOutputStatu.error;
              data = _yield$getOutputStatu.data;

              if (!(error || !data)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: error
              }));

            case 8:
              hasCostReviewStatus = data.getOutputStatuses.some(function (_ref3) {
                var name = _ref3.name;
                return name === 'COST_REVIEW';
              });

              if (hasCostReviewStatus) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                costReviewEnabled: false
              }));

            case 11:
              return _context.abrupt("return", void _this.setState({
                costReviewEnabled: true
              }));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "requestVideoBriefChanges", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var rejectionFeedback, requestVideoBriefChanges, _yield$requestVideoBr, error, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rejectionFeedback = _ref4.rejectionFeedback;
                requestVideoBriefChanges = _this.props.requestVideoBriefChanges;
                _context2.next = 4;
                return requestVideoBriefChanges(rejectionFeedback);

              case 4:
                _yield$requestVideoBr = _context2.sent;
                error = _yield$requestVideoBr.error;
                data = _yield$requestVideoBr.data;

                if (!(error || !data)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", void _this.setState({
                  error: error
                }));

              case 9:
                _this.fetchVideo();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onConfirmPayment", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
        var purchaseOrderId, hasCost, teamId, videoId, _this$state, video, costReviewEnabled, hasCostApprovalPermission;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                purchaseOrderId = _ref6.purchaseOrderId, hasCost = _ref6.hasCost, teamId = _ref6.teamId;
                videoId = _this.props.videoId;
                _this$state = _this.state, video = _this$state.video, costReviewEnabled = _this$state.costReviewEnabled, hasCostApprovalPermission = _this$state.hasCostApprovalPermission;

                if (!(!video || !videoId)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                if (!(hasCost && costReviewEnabled && !hasCostApprovalPermission)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", void _this.setState({
                  showReviewApprovalModal: true,
                  purchaseOrderId: purchaseOrderId,
                  hasCost: hasCost,
                  showPaymentsInvoiceModal: false
                }));

              case 7:
                _this.setState({
                  shouldShowPendingApprovalInformation: false
                });

                _context3.next = 10;
                return _this.submitVideoBrief({
                  purchaseOrderId: purchaseOrderId,
                  hasCost: hasCost,
                  teamId: teamId
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "submitVideoBrief", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
        var purchaseOrderId, hasCost, teamId, _this$props, submitVideo, history, videoId, video, _yield$submitVideo, error, data, status, masterOutput;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                purchaseOrderId = _ref8.purchaseOrderId, hasCost = _ref8.hasCost, teamId = _ref8.teamId;
                _this$props = _this.props, submitVideo = _this$props.submitVideo, history = _this$props.history, videoId = _this$props.videoId;
                video = _this.state.video;
                _context4.next = 5;
                return submitVideo({
                  purchaseOrderId: purchaseOrderId,
                  hasCost: hasCost,
                  teamId: teamId
                });

              case 5:
                _yield$submitVideo = _context4.sent;
                error = _yield$submitVideo.error;
                data = _yield$submitVideo.data;

                if (!(error || !data)) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return", void _this.setState({
                  error: error
                }));

              case 10:
                status = data.submitMasterOutput.status;

                if (!(status.name !== 'EDITING')) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return", void _this.setState({
                  showReviewApprovalModal: false,
                  shouldShowPendingApprovalButtons: false,
                  shouldShowPendingApprovalInformation: true
                }));

              case 13:
                if (!(!video || !videoId)) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt("return", void 0);

              case 15:
                masterOutput = video.outputs.find(function (_ref10) {
                  var isMaster = _ref10.isMaster;
                  return isMaster;
                });

                if (masterOutput) {
                  _context4.next = 18;
                  break;
                }

                return _context4.abrupt("return", void history.push("video-tool/project/".concat(video.videoProjectId)));

              case 18:
                history.rootPush("/review/".concat(videoId, "/").concat(masterOutput.outputId));

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchVideo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this$props2, fetchAssetsForResource, fetchAssets, history, videoId, getVideo, location, costReviewEnabled, stage, _yield$getVideo, error, data, video, project, permissions, hasUpdatePermission, hasDeleteAssetsPermission, hasArchiveAssetsPermission, hasCommentPermission, hasCostApprovalPermission, canUpdateVideo, shouldShowPendingApprovalInformation, shouldShowPendingApprovalButtons, optionalAssets;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props2 = _this.props, fetchAssetsForResource = _this$props2.fetchAssetsForResource, fetchAssets = _this$props2.fetchAssets, history = _this$props2.history, videoId = _this$props2.videoId, getVideo = _this$props2.getVideo, location = _this$props2.location;
              costReviewEnabled = _this.state.costReviewEnabled;

              if (videoId) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                video: null
              }));

            case 4:
              stage = _this.getStageFromLocation(location);
              _context5.next = 7;
              return getVideo();

            case 7:
              _yield$getVideo = _context5.sent;
              error = _yield$getVideo.error;
              data = _yield$getVideo.data;

              if (!(error || !data)) {
                _context5.next = 12;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                error: true
              }));

            case 12:
              video = data.getVideo, project = data.getProjectForVideo;

              if (!(!video || !project)) {
                _context5.next = 15;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                video: null,
                project: null
              }));

            case 15:
              permissions = video.permissions;
              hasUpdatePermission = (0, _commonReact.hasPermission)('UPDATE', permissions);
              hasDeleteAssetsPermission = (0, _commonReact.hasPermission)('DELETE_ASSET', permissions);
              hasArchiveAssetsPermission = (0, _commonReact.hasPermission)('ARCHIVE', permissions);
              hasCommentPermission = (0, _commonReact.hasPermission)('COMMENT', permissions);
              hasCostApprovalPermission = (0, _commonReact.hasPermission)('COST_APPROVAL', permissions);
              canUpdateVideo = hasUpdatePermission && !video.outputs.some(function (_ref12) {
                var status = _ref12.status;
                return status.name !== 'DRAFT';
              });
              shouldShowPendingApprovalInformation = _this.shouldShowPendingApprovalInformation(video, hasCostApprovalPermission);
              shouldShowPendingApprovalButtons = _this.shouldShowPendingApprovalButtons(video, hasCostApprovalPermission);
              optionalAssets = [video.introAnimationId, video.lowerThirdId].filter(Boolean);

              if (optionalAssets.length) {
                fetchAssets({
                  assetIds: optionalAssets
                });
              }

              fetchAssetsForResource({
                data: {
                  assetIds: (0, _lodash3.default)(video.assetIds)
                },
                resourceId: video.videoId,
                organisationId: video.organisationId
              });

              _this.setState({
                video: sortClips((0, _stripCacheKeysFromData.default)(video)),
                project: _objectSpread({}, project, {
                  assignedLabels: project.assignedLabels || {},
                  labels: project.labels && project.labels.length ? project.labels : _defaultLabels.default
                }),
                canUpdateVideo: canUpdateVideo,
                hasUpdatePermission: hasUpdatePermission,
                hasDeleteAssetsPermission: hasDeleteAssetsPermission,
                hasArchiveAssetsPermission: hasArchiveAssetsPermission,
                hasCommentPermission: hasCommentPermission,
                hasCostApprovalPermission: hasCostApprovalPermission,
                costReviewEnabled: costReviewEnabled,
                shouldShowPendingApprovalInformation: shouldShowPendingApprovalInformation,
                shouldShowPendingApprovalButtons: shouldShowPendingApprovalButtons
              }, function () {
                if ((0, _utils.isValidStage)(stage, video)) {
                  return;
                }

                history.push('#1');
              });

            case 28:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "onModifyAddons", function () {
      var history = _this.props.history;

      _this.setState({
        showPaymentsInvoiceModal: false
      });

      history.push('#4');
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveOutputs", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(outputs) {
        var updateAllOutputs, video, _yield$updateAllOutpu, data, error, updateAllOutputsForVideo;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                updateAllOutputs = _this.props.updateAllOutputs;
                video = _this.state.video;

                _this.setState({
                  saving: true
                });

                _context6.next = 5;
                return updateAllOutputs(outputs);

              case 5:
                _yield$updateAllOutpu = _context6.sent;
                data = _yield$updateAllOutpu.data;
                error = _yield$updateAllOutpu.error;

                if (!(!data || error || !data.updateAllOutputsForVideo)) {
                  _context6.next = 11;
                  break;
                }

                _this.setState({
                  saving: false
                });

                return _context6.abrupt("return", {
                  error: true
                });

              case 11:
                updateAllOutputsForVideo = data.updateAllOutputsForVideo;

                _this.setState({
                  video: _objectSpread({}, video, {
                    outputs: (0, _stripCacheKeysFromData.default)(updateAllOutputsForVideo)
                  }),
                  saving: false
                });

                return _context6.abrupt("return", {});

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref13.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "updateProject", function (projectChanges) {
      var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          override = _ref14.override;

      return new Promise(function (resolve) {
        _this.setState(function (_ref15) {
          var project = _ref15.project;
          return {
            project: override ? _objectSpread({}, project, {}, projectChanges) : (0, _lodash.default)(_objectSpread({}, project), projectChanges)
          };
        }, resolve);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateVideo", function (videoChanges) {
      var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          override = _ref16.override;

      return new Promise(function (resolve) {
        _this.setState(function (_ref17) {
          var video = _ref17.video;
          return {
            video: override ? _objectSpread({}, video, {}, videoChanges) : (0, _lodash.default)(_objectSpread({}, video), videoChanges),
            refetchComments: Boolean(video && videoChanges.editingMode !== video.editingMode)
          };
        }, resolve);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createVideo", /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref18) {
        var name, _this$props3, createVideo, history, getProject, _this$props3$location, state, videoFolderId, videoProjectId, _yield$createVideo, error, data, video, permissions, hasCostApprovalPermission, hasDeleteAssetsPermission, hasArchiveAssetsPermission, _yield$getProject, projectData, projectName;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                name = _ref18.name;
                _this$props3 = _this.props, createVideo = _this$props3.createVideo, history = _this$props3.history, getProject = _this$props3.getProject, _this$props3$location = _this$props3.location.state, state = _this$props3$location === void 0 ? {} : _this$props3$location;
                videoFolderId = state.videoFolderId, videoProjectId = state.videoProjectId;

                _this.setState({
                  creating: true
                });

                _context7.next = 6;
                return createVideo({
                  name: name,
                  videoFolderId: videoFolderId,
                  videoProjectId: videoProjectId
                });

              case 6:
                _yield$createVideo = _context7.sent;
                error = _yield$createVideo.error;
                data = _yield$createVideo.data;

                if (!(error || !data || !data.createVideo)) {
                  _context7.next = 11;
                  break;
                }

                return _context7.abrupt("return", void _this.setState({
                  creating: false
                }));

              case 11:
                video = data.createVideo;
                permissions = video.permissions;
                hasCostApprovalPermission = (0, _commonReact.hasPermission)('COST_APPROVAL', permissions);
                hasDeleteAssetsPermission = (0, _commonReact.hasPermission)('DELETE_ASSET', permissions);
                hasArchiveAssetsPermission = (0, _commonReact.hasPermission)('ARCHIVE', permissions);
                _context7.next = 18;
                return getProject(video.videoProjectId);

              case 18:
                _yield$getProject = _context7.sent;
                projectData = _yield$getProject.data; // Default this because we can silently ignore this error

                projectName = (0, _lodash2.default)(projectData, 'getVideoProject.name', 'Unknown Project');

                _this.setState({
                  video: _objectSpread({}, video, {
                    outputs: (0, _stripCacheKeysFromData.default)(video.outputs)
                  }),
                  project: _objectSpread({
                    videoProjectId: video.videoProjectId,
                    name: projectName,
                    organisationId: video.organisationId
                  }, NEW_PROJECT),
                  hasCostApprovalPermission: hasCostApprovalPermission,
                  creating: false,
                  canUpdateVideo: true,
                  hasUpdatePermission: true,
                  hasDeleteAssetsPermission: hasDeleteAssetsPermission,
                  hasArchiveAssetsPermission: hasArchiveAssetsPermission,
                  hasCommentPermission: true,
                  shouldShowPendingApprovalInformation: false,
                  shouldShowPendingApprovalButtons: false
                }, function () {
                  history.push("/builder/".concat(video.videoId, "#1"));
                });

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x5) {
        return _ref19.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "goToNextStage", function () {
      var _this$props4 = _this.props,
          history = _this$props4.history,
          location = _this$props4.location;

      var stage = _this.getStageFromLocation(location);

      _this.setState({
        selectedDrawerAssets: []
      });

      _this.openDrawerToMedia(stage + 1);

      history.push("#".concat(stage + 1));
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      var _this$props5 = _this.props,
          history = _this$props5.history,
          location = _this$props5.location;

      var stage = _this.getStageFromLocation(location);

      _this.setState({
        selectedDrawerAssets: []
      });

      _this.openDrawerToMedia(stage - 1);

      history.push("#".concat(stage - 1));
    });

    _defineProperty(_assertThisInitialized(_this), "onClickStage", function (stage) {
      var history = _this.props.history;
      var video = _this.state.video;
      var isValid = (0, _utils.isValidStage)(stage, video);

      if (!isValid) {
        return;
      }

      _this.setState({
        selectedDrawerAssets: []
      });

      _this.openDrawerToMedia(stage);

      history.push("#".concat(stage));
    });

    _defineProperty(_assertThisInitialized(_this), "setDrawerRef", function (ref) {
      if (!ref) {
        return;
      }

      var location = _this.props.location;

      _this.setState({
        drawerRef: ref
      }, function () {
        var stage = _this.getStageFromLocation(location);

        _this.openDrawerToMedia(stage);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openDrawerToMedia", function (stage) {
      var drawerRef = _this.state.drawerRef;

      if (stage !== 2) {
        return void (0, _utils.openDrawerTab)(drawerRef, 0, {
          stayClosed: true
        })();
      }

      (0, _utils.openDrawerTab)(drawerRef, 1)();
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _this$props6, updateVideo, updateProject, _this$state2, video, project, refetchComments, _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, videoData, error, updatedVideo, newVideo;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this$props6 = _this.props, updateVideo = _this$props6.updateVideo, updateProject = _this$props6.updateProject;
              _this$state2 = _this.state, video = _this$state2.video, project = _this$state2.project, refetchComments = _this$state2.refetchComments;

              if (video) {
                _context8.next = 4;
                break;
              }

              return _context8.abrupt("return", {
                error: true
              });

            case 4:
              _this.setState({
                saving: true
              });

              _context8.next = 7;
              return Promise.all([updateVideo(video), updateProject({
                input: project,
                videoProjectId: video.videoProjectId
              })]);

            case 7:
              _yield$Promise$all = _context8.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              _yield$Promise$all2$ = _yield$Promise$all2[0];
              videoData = _yield$Promise$all2$.data;
              error = _yield$Promise$all2$.error;

              if (!(error || !videoData || !videoData.updateVideo)) {
                _context8.next = 15;
                break;
              }

              _this.setState({
                saving: false
              });

              return _context8.abrupt("return", {
                error: true
              });

            case 15:
              if (refetchComments && _this._commentsRef) {
                _this._commentsRef.fetchComments(video.videoId);
              }

              updatedVideo = videoData.updateVideo;
              newVideo = (0, _lodash.default)(_objectSpread({}, video), sortClips(updatedVideo));

              _this.setState({
                saving: false,
                video: newVideo
              });

              return _context8.abrupt("return", {});

            case 20:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSaveAndClose", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var history, _this$state3, video, canUpdateVideo, _yield$_this$onSave, error;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              history = _this.props.history;
              _this$state3 = _this.state, video = _this$state3.video, canUpdateVideo = _this$state3.canUpdateVideo;

              if (video) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt("return");

            case 4:
              if (canUpdateVideo) {
                _context9.next = 6;
                break;
              }

              return _context9.abrupt("return", void history.push('/'));

            case 6:
              _context9.next = 8;
              return _this.onSave();

            case 8:
              _yield$_this$onSave = _context9.sent;
              error = _yield$_this$onSave.error;

              if (!error) {
                _context9.next = 12;
                break;
              }

              return _context9.abrupt("return");

            case 12:
              history.push('/');

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })));

    _defineProperty(_assertThisInitialized(_this), "setCommentFilterClip", function (clip) {
      if (!clip) {
        return;
      }

      _this.setState({
        commentFilterClip: clip
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectBasicComment", function (_, comment) {
      var video = _this.state.video;
      var clipId = comment.clipId,
          assetId = comment.assetId;

      if (!assetId && !clipId || !video) {
        return;
      }

      _this.setState({
        commentFilterClip: video.clips.find(function (clip) {
          // Old comments won't have clipId.
          if (!clipId) {
            return clip.assetId === assetId;
          }

          return clip.clipId === clipId;
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setCommentsRef", function (el) {
      if (!el) {
        return;
      }

      _this._commentsRef = el;
    });

    _defineProperty(_assertThisInitialized(_this), "getMasterOutput", function (video) {
      var masterOutput = video.outputs.find(function (output) {
        return output.isMaster;
      });
      return masterOutput;
    });

    _defineProperty(_assertThisInitialized(_this), "onCloseFeedbackModal", function () {
      _this.setState({
        isFeedbackModalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "returnFeedback", function () {
      _this.setState({
        isFeedbackModalVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldShowPendingApprovalButtons", function (video, hasCostApprovalPermission) {
      if (!video) {
        return false;
      }

      var costReviewEnabled = _this.state.costReviewEnabled;

      var masterOutput = _this.getMasterOutput(video);

      return Boolean(costReviewEnabled && hasCostApprovalPermission && masterOutput && masterOutput.status.name === 'COST_REVIEW' && video.submittedAt === null);
    });

    _defineProperty(_assertThisInitialized(_this), "shouldShowPendingApprovalInformation", function (video, hasCostApprovalPermission) {
      if (!video) {
        return false;
      }

      var costReviewEnabled = _this.state.costReviewEnabled;

      var masterOutput = _this.getMasterOutput(video);

      return !(!costReviewEnabled || hasCostApprovalPermission || masterOutput.status.name !== 'COST_REVIEW' || video.submittedAt !== null);
    });

    _defineProperty(_assertThisInitialized(_this), "submitForReviewApproval", function (purchaseOrderId, hasCost) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return _this.submitVideoBrief({
                    purchaseOrderId: purchaseOrderId,
                    hasCost: hasCost
                  });

                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "closeReviewApprovalModal", function () {
      _this.setState({
        showReviewApprovalModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateSelectedDrawerAssets", function (selected) {
      _this.setState({
        selectedDrawerAssets: selected
      });
    });

    var _location = props.location,
        _history = props.history,
        _videoId = props.videoId;

    if (_videoId && !_location.hash) {
      _history.replace('#1');
    }

    _this.state = {
      saving: false,
      creating: false,
      error: false,
      canUpdateVideo: false,
      hasUpdatePermission: false,
      hasDeleteAssetsPermission: false,
      hasArchiveAssetsPermission: false,
      hasCommentPermission: false,
      hasCostApprovalPermission: true,
      shouldShowPendingApprovalInformation: false,
      shouldShowPendingApprovalButtons: false,
      isFeedbackModalVisible: false,
      showPaymentsInvoiceModal: false,
      showReviewApprovalModal: false,
      costReviewEnabled: true,
      refetchComments: false,
      hasCost: false,
      purchaseOrderId: '',
      selectedDrawerAssets: []
    };
    return _this;
  }

  _createClass(VideoTool, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.onbeforeunload = function () {
        return true;
      };

      this.setCostReviewStatus();
      this.fetchVideo();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.onbeforeunload = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          video = _this$state4.video,
          project = _this$state4.project,
          drawerRef = _this$state4.drawerRef,
          creating = _this$state4.creating,
          error = _this$state4.error,
          saving = _this$state4.saving,
          canUpdateVideo = _this$state4.canUpdateVideo,
          hasUpdatePermission = _this$state4.hasUpdatePermission,
          hasDeleteAssetsPermission = _this$state4.hasDeleteAssetsPermission,
          hasArchiveAssetsPermission = _this$state4.hasArchiveAssetsPermission,
          hasCommentPermission = _this$state4.hasCommentPermission,
          hasCostApprovalPermission = _this$state4.hasCostApprovalPermission,
          costReviewEnabled = _this$state4.costReviewEnabled,
          shouldShowPendingApprovalInformation = _this$state4.shouldShowPendingApprovalInformation,
          shouldShowPendingApprovalButtons = _this$state4.shouldShowPendingApprovalButtons,
          isFeedbackModalVisible = _this$state4.isFeedbackModalVisible,
          showPaymentsInvoiceModal = _this$state4.showPaymentsInvoiceModal,
          showReviewApprovalModal = _this$state4.showReviewApprovalModal,
          commentFilterClip = _this$state4.commentFilterClip,
          purchaseOrderId = _this$state4.purchaseOrderId,
          hasCost = _this$state4.hasCost,
          selectedDrawerAssets = _this$state4.selectedDrawerAssets;
      var _this$props7 = this.props,
          archiveAssets = _this$props7.archiveAssets,
          deleteAssets = _this$props7.deleteAssets,
          archiveAsset = _this$props7.archiveAsset,
          fetchAssetsForResource = _this$props7.fetchAssetsForResource;
      var _this$props8 = this.props,
          history = _this$props8.history,
          videoId = _this$props8.videoId,
          submitVideo = _this$props8.submitVideo,
          location = _this$props8.location;
      var stage = this.getStageFromLocation(location);

      if (!videoId && !video) {
        return (/*#__PURE__*/_react.default.createElement(_pages.CreateVideo, {
            history: history,
            onSave: this.createVideo,
            saving: creating
          })
        );
      }

      if (error) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.Error, null)
        );
      } // Initial video state (undefined)


      if (video === void 0 || project === void 0 || creating) {
        return (/*#__PURE__*/_react.default.createElement(_uiKit.Loader, {
            darkTheme: true
          })
        );
      } // Video doesn't exist (null)


      if (!video || !project) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.NotFound, null)
        );
      }

      var permissions = video.permissions;
      var masterOutput = this.getMasterOutput(video);
      return (/*#__PURE__*/_react.default.createElement(_VideoContext.default.Provider, {
          value: (0, _videoToolContext.default)({
            state: {
              video: video,
              project: project,
              saving: saving,
              canUpdateVideo: canUpdateVideo,
              hasUpdatePermission: hasUpdatePermission,
              hasDeleteAssetsPermission: hasDeleteAssetsPermission,
              hasArchiveAssetsPermission: hasArchiveAssetsPermission,
              hasCostApprovalPermission: hasCostApprovalPermission,
              costReviewEnabled: costReviewEnabled,
              shouldShowPendingApprovalInformation: shouldShowPendingApprovalInformation,
              shouldShowPendingApprovalButtons: shouldShowPendingApprovalButtons,
              showPaymentsInvoiceModal: showPaymentsInvoiceModal,
              isFeedbackModalVisible: isFeedbackModalVisible,
              commentFilterClip: commentFilterClip,
              purchaseOrderId: purchaseOrderId,
              hasCost: hasCost,
              selectedDrawerAssets: selectedDrawerAssets
            },
            actions: {
              updateProject: this.updateProject,
              deleteAssets: deleteAssets,
              archiveAssets: archiveAssets,
              archiveAsset: archiveAsset,
              updateVideo: this.updateVideo,
              onSaveOutputs: this.onSaveOutputs,
              onSave: this.onSave,
              submitVideo: submitVideo,
              setCommentFilterClip: this.setCommentFilterClip,
              returnFeedback: this.returnFeedback,
              openPaymentsInvoiceModal: this.openPaymentsInvoiceModal,
              fetchAssetsForResource: fetchAssetsForResource
            }
          })
        }, /*#__PURE__*/_react.default.createElement(_commonReact.CommentsProvider, {
          ref: this.setCommentsRef,
          resourceId: video.videoId,
          resourceOrganisationId: video.organisationId,
          isReadOnly: !hasCommentPermission
        }, /*#__PURE__*/_react.default.createElement(_ReturnFeedbackModal.default, {
          hasCostApprovalPermission: hasCostApprovalPermission,
          onSave: this.requestVideoBriefChanges,
          onClose: this.onCloseFeedbackModal,
          visible: isFeedbackModalVisible
        }), /*#__PURE__*/_react.default.createElement(_SubmitForReviewApprovalModal.default, {
          visible: showReviewApprovalModal,
          onConfirm: this.submitForReviewApproval(purchaseOrderId, hasCost),
          onClose: this.closeReviewApprovalModal,
          videoName: video.name
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "video-tool-root page__full"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-tool-root__content"
        }, /*#__PURE__*/_react.default.createElement(_Header.default, {
          currentStage: stage,
          onClickStage: this.onClickStage,
          drawerRef: drawerRef,
          onUpdateVideo: this.updateVideo,
          name: video.name,
          onSave: this.onSaveAndClose,
          saving: saving,
          canUpdateVideo: canUpdateVideo,
          videoPermissions: permissions,
          videoId: video.videoId,
          organisationId: video.organisationId,
          projectName: project.name,
          selectedClips: video.assetIds ? video.assetIds.length : 0,
          orderedClips: video.clips ? video.clips.length : 0,
          video: video
        }), /*#__PURE__*/_react.default.createElement(_commonReact.AddonsProvider, {
          loaderProps: {
            darkTheme: true
          }
        }, /*#__PURE__*/_react.default.createElement(_commonReact.PaymentsInvoice, {
          visible: showPaymentsInvoiceModal,
          onConfirm: this.onConfirmPayment,
          onModifyAddons: this.onModifyAddons,
          videoOutputs: video.outputs,
          videoName: video.name,
          addonsSelector: "appliedAddons",
          onClose: this.closePaymentsInvoiceModal,
          showCreditInfo: masterOutput && masterOutput.status.name === 'DRAFT' && !video.submittedAt
        }), /*#__PURE__*/_react.default.createElement(_Stage.default, {
          stageNumber: stage,
          goToNextStage: this.goToNextStage,
          goBack: this.goBack
        }))), /*#__PURE__*/_react.default.createElement(_reactResponsive.default, {
          minWidth: 800
        }, /*#__PURE__*/_react.default.createElement(_AssetDrawer.default, {
          ref: this.setDrawerRef,
          hiddenIndexes: stage !== 2 ? [1, 2] : void 0,
          stage: stage,
          video: video,
          commentFilterClip: commentFilterClip,
          onSelectBasicComment: this.onSelectBasicComment,
          onUpdateSelectedDrawerAssets: this.onUpdateSelectedDrawerAssets
        })))))
      );
    }
  }]);

  return VideoTool;
}(_react.Component);

exports.default = VideoTool;